import moment from "moment";
import React, { CSSProperties, useEffect, useMemo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { adToBe } from "react-lib/utils/dateUtils";
import { Button, Divider, Grid, Icon, Image } from "semantic-ui-react";
import ButtonPayment from "bplus-lib/telephar/ButtonPayment";
import MessageContentHTML from "react-lib/apps/IsHealth/Chat/MessageContentHTML";
import { InsuranceDataFormatType } from "bplus-lib/insurance/InsuranceType";
import ProxyOrganizationSerializer from "issara-sdk/types/ProxyOrganizationSerializer_apps_PRX";

type DialogBoxPreVerificationProps = {
  contentType: any;
  contentPayload: any;
  channelId: any;
  content: string;
  submissionsList: InsuranceDataFormatType[];
  loadingStatus: boolean;
  organizationDetail: ProxyOrganizationSerializer;
};

const IMAGES = {
  check: "/images/Appointment/icon_check_blue.png",
};

// Styles
const COLORS = {
  primary: "var(--blue-bdms-color)",
  lightBlue: "#ECF4FF",
};

const typeToCloseButton = ["INS_verify_canceled", "INS_benefit_expired"];
const typeToDetail = ["INS_coverage", "INS_not_covered", "INS_not_found"];

const DialogBoxPreVerification = (props: DialogBoxPreVerificationProps) => {
  const intl = useIntl();
  const isDisable = useMemo(() => {
    const expireDate = props.contentPayload?.meta?.expire || "";
    // ถ้าเกิน expireDate
    const isExpired = moment(expireDate).isBefore(moment(), "day");

    return expireDate !== "" ? isExpired : true;
  }, [props.contentPayload]);

  // handleLoadSubmitFormPrever คือจุดที่เรียก submissionsList

  const submissionData = useMemo(() => {
    const appointmentList = props.contentPayload?.meta?.appointment || [];
    let selectedAppointment = {};
    let selectedSubmission: InsuranceDataFormatType | any = {};
    // ดึง submission เพื่อเช็คว่าทำก่อนหรือหลัง chat ปัจจุบัน ใช้เป็นเงื่อนไขในการแสดงปุ่ม
    (appointmentList || []).forEach((item: any) => {
      const selectedSubmiss = (props.submissionsList || [])
        .filter((i) => i.en === item.en)
        .filter((item: any) => item.status !== "Cancelled")
        .sort(
          (a, b) =>
            moment(a.submission_datetime).valueOf() -
            moment(b.submission_datetime).valueOf(),
        )[0];
      if (selectedSubmiss) {
        selectedAppointment = item;
        selectedSubmission = selectedSubmiss;
      }
    });

    const submissionDate = selectedSubmission.submission_datetime;

    const isExpired =
      submissionDate && props.contentPayload.send_at
        ? !moment(submissionDate).isAfter(
            moment(props.contentPayload.send_at, "DD/MM/YYYY HH:mm"),
          )
        : false;

    return {
      isExpired: isExpired,
      isSubmiss: !!selectedSubmission.submission_datetime,
    };
  }, [props.contentPayload, props.submissionsList]);

  const handleChangeTabNative = (newTab: string) => {
    if (window.MobNative?.changeToNative) {
      window.MobNative?.changeToNative(newTab);
    }
    if (window.iosNative?.changeToNative) {
      window.iosNative?.changeToNative(newTab);
    }
  };

  const isSubmissForm = useMemo(() => {
    return (
      submissionData.isSubmiss &&
      !submissionData.isExpired &&
      !typeToDetail.includes(props.contentPayload.triage_level)
    );
  }, [submissionData]);

  return (
    <div>
      <MessageContentHTML content={props.content} overrideCSS={true} />
      {(!submissionData.isExpired ||
        typeToDetail.includes(props.contentPayload.triage_level)) &&
        !typeToCloseButton.includes(props.contentPayload.triage_level) &&
        props.organizationDetail?.is_enable_preverify && (
          <ButtonPayment
            title={
              <div
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                {isSubmissForm && <img src={IMAGES.check} />}
                <FormattedMessage
                  id={
                    typeToDetail.includes(props.contentPayload.triage_level)
                      ? "bplusClinicKey1149"
                      : isSubmissForm
                      ? "bplusClinicKey1497"
                      : "bplusClinicKey1486"
                  }
                />
              </div>
            }
            isLoad={
              props.loadingStatus &&
              !typeToDetail.includes(props.contentPayload.triage_level)
            }
            style={{
              padding: "9px 31px",
              minWidth: "200px",
              ...(isSubmissForm && {
                background: COLORS.lightBlue,
                color: COLORS.primary,
              }),
            }}
            // callback
            disabled={
              isDisable &&
              !typeToDetail.includes(props.contentPayload.triage_level)
            }
            onClick={() => handleChangeTabNative("PreVerification")}
          />
        )}
    </div>
  );
};

export default React.memo(DialogBoxPreVerification);
